import { StyleOfText } from "./textStyle";
import { createMovieClip } from "./functions/Functions_General";
import { getParameterByName } from "./getParameters";
import { CommonData } from "./datastructures/gamestate/gameData";

//Message Window
//needd to load  image with name "messageFrameFire" for frames

export class PopupMessageBox {
  private parent: PIXI.Container;
  private nullPosition: PIXI.Container;
  private messageBoxContainer: PIXI.Container;
  private messageElemContainer: PIXI.Container;
  private isOpen: boolean;
  private headText: PIXI.Text;
  private bodyText1: PIXI.Text;
  private bodyText2: PIXI.Text;


  // private fireFrame: PIXI.extras.AnimatedSprite;
  private messageBoxBG: PIXI.Graphics;

  private boxWidth: number;
  private boxHeight: number;
  private btnContainer: PIXI.Container;
  private btnCount: number;
  private btnShape: Array<PIXI.Graphics>;
  private btnLabel: Array<PIXI.Text>;
  private roundness: number;
  private headTextStyle: PIXI.TextStyle;
  private bodyText1Style: PIXI.TextStyle;
  private labelTextStyle: PIXI.TextStyle;
  private parentSize: Array<number>;
  private messageBoxInTween: PIXI.tween.Tween;
  private messageBoxOutTween: PIXI.tween.Tween;
  private gameTextStyle: StyleOfText;
  private autoResizeMobilePortrait: boolean;
  private isMobile: boolean;
  private activeGameData: CommonData;
  private extrasElementBgAddParent:PIXI.Container;

  //---advanced look
  private msgFrame: PIXI.Sprite;
  private msgErrTexture: PIXI.Texture;
  private msgWinTexture: PIXI.Texture;
  private msgDefaultTexture: PIXI.Texture;
  private msgDecorations: Array<PIXI.Sprite | PIXI.extras.AnimatedSprite>;
  private errorIcon: PIXI.Sprite;
  private winElements: PIXI.Sprite;
  // private winElementsR:PIXI.Sprite;
  private inFocusBG: PIXI.Graphics;
  private msgPulseBGMask: PIXI.Sprite;
  private msgPulseBG: PIXI.extras.AnimatedSprite;

  private winBGFx_L:PIXI.Sprite;
  private winBGFx_R:PIXI.Sprite;
  private msgBoxSize:Array<number>;
  private enableBlackenScreen:boolean=true;
  constructor(
    totalBtn: number,
    size: Array<number>,
    activeGameData: CommonData //message box dimension and nbr of btn
  ) {
    this.msgBoxSize = [800, 350];

    this.activeGameData = activeGameData;
    this.autoResizeMobilePortrait = true;
    this.gameTextStyle = new StyleOfText();

    this.parent = new PIXI.Container();
    this.parent.alpha = 0;
    this.nullPosition = new PIXI.Container();
    this.messageBoxContainer = new PIXI.Container();
    this.parent.addChild(this.nullPosition);
    this.nullPosition.addChild(this.messageBoxContainer);

    this.messageBoxContainer.alpha = 1;

    this.winBGFx_L=new PIXI.Sprite(
      PIXI.Texture.fromFrame("winFx.png")
    );
    this.winBGFx_L.anchor.set(1,0.5);
    this.winBGFx_L.blendMode=PIXI.BLEND_MODES.ADD;
    this.winBGFx_L.position.set(this.activeGameData.size[0] / 2,this.activeGameData.size[1] / 2)
    this.nullPosition.addChild(this.winBGFx_L);

    this.winBGFx_R=new PIXI.Sprite(
      PIXI.Texture.fromFrame("winFx.png")
    );
    this.winBGFx_R.anchor.set(1,0.5);
    this.winBGFx_R.scale.set(-1,1)
    this.winBGFx_R.blendMode=PIXI.BLEND_MODES.ADD;
    this.winBGFx_R.position.set(this.activeGameData.size[0] / 2,this.activeGameData.size[1] / 2)
    this.nullPosition.addChild(this.winBGFx_R);

    
    this.msgDecorations = [];



    this.msgDecorations.push(this.winBGFx_L);
    this.msgDecorations.push(this.winBGFx_R);


    this.msgErrTexture = PIXI.Texture.fromFrame("msgbox2.png");
    this.msgDefaultTexture = PIXI.Texture.fromFrame("msgbox1.png");
    this.msgWinTexture = PIXI.Texture.fromFrame("msgbox4.png");
    this.msgFrame = new PIXI.Sprite(this.msgDefaultTexture);
    this.msgFrame.anchor.set(0.5);
    this.msgFrame.alpha=.7;
    this.msgFrame.position.set(
      this.activeGameData.size[0] / 2,
      this.activeGameData.size[1] / 2 - 20
    );

    this.nullPosition.addChild(this.msgFrame);


    this.winElements = new PIXI.Sprite(
      PIXI.Texture.fromFrame("msgbox4_deco.png")
    );
    this.winElements.anchor.set(0.5);
    // this.winElementsL.alpha=.35;
    this.winElements.y = this.activeGameData.size[1] / 2 - 41;
    this.winElements.x = this.activeGameData.size[0] / 2-1;
    this.nullPosition.addChild(this.winElements);
    this.msgDecorations.push(this.winElements);

    this.msgPulseBGMask = new PIXI.Sprite(this.msgDefaultTexture);
    this.msgPulseBGMask.anchor.set(0.5);
    this.msgPulseBGMask.tint = 0x000000;
    this.msgFrame.addChild(this.msgPulseBGMask);

    this.msgPulseBG = createMovieClip("msgbox_pulse", 0, 30);
    this.msgFrame.addChild(this.msgPulseBG);
    // this.msgPulseBG.blendMode=PIXI.BLEND_MODES.ADD;
    this.msgPulseBG.anchor.set(0.5);
    this.msgPulseBG.width = this.msgErrTexture.width;
    // this.

    this.msgPulseBG.loop = true;
    this.msgPulseBG.gotoAndPlay(0);

    this.msgPulseBG.mask = this.msgPulseBGMask;
    



    this.extrasElementBgAddParent = new PIXI.Container();
    this.nullPosition.addChild(this.extrasElementBgAddParent);

    this.extrasElementBgAddParent.position.set(
      -this.msgBoxSize[0] / 2 + this.activeGameData.size[0] / 2,
      -this.msgBoxSize[1] / 2 + this.activeGameData.size[1] / 2
    );

    this.messageElemContainer = new PIXI.Container();
    this.nullPosition.addChild(this.messageElemContainer);
    this.messageElemContainer.position.set(
      -this.msgBoxSize[0] / 2 + this.activeGameData.size[0] / 2,
      -this.msgBoxSize[1] / 2 + this.activeGameData.size[1] / 2
    );


    this.errorIcon = new PIXI.Sprite(
      PIXI.Texture.fromFrame("msgbox_error.png")
    );
    this.errorIcon.anchor.set(0.5);
    this.errorIcon.alpha = 0.35;
    this.errorIcon.y = -50;
    this.msgFrame.addChild(this.errorIcon);

    this.msgDecorations.push(this.errorIcon);

   

    // this.fireFrame = createMovieClip("messageFrameFire", 0, 8);
    // this.fireFrame.animationSpeed = 0.25;
    this.isOpen = false;
    this.messageBoxBG;
    this.headText;
    this.bodyText1;
    this.boxWidth = this.msgBoxSize[0];
    this.boxHeight = this.msgBoxSize[1];
    this.btnContainer = new PIXI.Container();
    this.btnCount = totalBtn;
    this.parentSize = size;
    this.btnShape = [];
    this.btnLabel = [];

    this.roundness = 5;

    this.headTextStyle = new PIXI.TextStyle({
      fontFamily: this.gameTextStyle.gameFont,
      dropShadow: true,
      dropShadowColor: "#d44a2d",
      dropShadowBlur: 10,
      dropShadowAngle: Math.PI / 6,
      dropShadowDistance: 0,
      fill: ["#ffffff"],
      fontWeight: "bold",
      fontSize: 45,
      align: "center",
      wordWrap: true,
      wordWrapWidth: this.boxWidth - 100,
    });

    this.bodyText1Style = new PIXI.TextStyle({
      fontFamily: this.gameTextStyle.gameFont,
      dropShadow: true,
      dropShadowColor: "#d44a2d",
      dropShadowBlur: 10,
      dropShadowAngle: Math.PI / 6,
      dropShadowDistance: 0,
      fill: ["#ffffff"],
      fontWeight: "bold",
      fontSize: 30,
      align: "center",
      wordWrap: true,
      wordWrapWidth: this.boxWidth - 100,
    });

    this.labelTextStyle = new PIXI.TextStyle({
      fontFamily: this.gameTextStyle.gameFont,
      dropShadow: true,
      dropShadowColor: "#d44a2d",
      dropShadowBlur: 10,
      dropShadowAngle: Math.PI / 6,
      dropShadowDistance: 0,
      fill: ["#000000"],
      fontWeight: "bold",
      fontSize: 30,
      align: "center",
      wordWrap: true,
      wordWrapWidth: this.boxWidth - 100,
    });

    //---create in focus bg
    this.inFocusBG = new PIXI.Graphics();
    this.inFocusBG.beginFill(0xff0000);
    this.inFocusBG.drawRect(0, 0, 1920, 1080);
    this.inFocusBG.endFill();
    this.inFocusBG.alpha = 0;
    // this.activeGameData.messageBGContainer.addChild(this.inFocusBG);

    this.createBox();
    this.createTween();
    //add listener
    if (this.autoResizeMobilePortrait) {
      this.isMobile = getParameterByName("mobile") == "true";
      if (this.isMobile) {
        let self = this;
        window.addEventListener(
          "orientationchange",
          function() {
            self.scaleMessageWindow();
          },
          false
        );
        window.addEventListener(
          "resize",
          function() {
            self.scaleMessageWindow();
          },
          false
        );
      }

      this.scaleMessageWindow();
    }

    this.setMessageBoxVisibile(false);
    //-replace the set child of  with automated parent from activeGameData
    this.setPositionAndParent()
  }
  public getParent=():PIXI.Container=>
  {
    return this.parent;
  }
  public getFrame=():PIXI.Sprite=>
  {
    return this.msgFrame;
  }

  public getFramenull=():PIXI.Container=>
  {
    return this.extrasElementBgAddParent;
  }

  public setAlphaDefaultFrame=(newAlpha:number):void=>
  {
    this.msgFrame.alpha=newAlpha;
  }
  private scaleMessageWindow() {
    //  doubleScaleOnPortrait(this.isMobile,this.parent,this.parentSize,1.25);
    // console.log(this.parent.scale.x)
    // doubleScaleOnPortrait(this.isMobile,this.parent,this.parentSize,this.activeGameData.scaleMessageBoxPortrait);

    this.MessageScaleOnPortrait(this.isMobile, this.parent, this.parentSize);
  }
  public setTint=(rgb:number):void=>
  {
    this.msgPulseBGMask.tint=rgb;this.bodyText1.tint=rgb;
  }
  private MessageScaleOnPortrait(
    isMobile: boolean,
    containerToScale: PIXI.Container,
    size: Array<number>
  ) {
    if (window.matchMedia("(orientation: portrait)").matches && isMobile ) {

      let isPortraitVisible=true
      if( this.activeGameData.mobilePortraitUI!=undefined)
      {
        isPortraitVisible=this.activeGameData.mobilePortraitUI.getParent().alpha==1
      }
      
      if(isPortraitVisible)
      {
        let newScale = 1.6;      
        containerToScale.scale.set(newScale);
        containerToScale.x = -(size[0] * newScale - size[0]) / 2;
        containerToScale.y = -(size[1] * newScale - size[1]) / 2 + 40;
      }
   
    } else {
      containerToScale.scale.set(1);
      containerToScale.x = 0;
      containerToScale.y = 0;
    }
    // if (window.matchMedia("(orientation: portrait)").matches && isMobile) {
    //   let newScale = 2.1;      
    //   containerToScale.scale.set(newScale);
    //   containerToScale.x = -(size[0] * newScale - size[0]) / 2;
    //   containerToScale.y = -(size[1] * newScale - size[1]) / 2 + 40;
    // } else {
    //   containerToScale.scale.set(1);
    //   containerToScale.x = 0;
    //   containerToScale.y = 0;
    // }
  }

  private createBox = (): void => {
    this.messageBoxBG = new PIXI.Graphics();
    // this.messageBoxBG.lineStyle(10, 0xffc880, .5,2);
    // this.messageBoxBG.beginFill(0x4f0726);
    this.messageBoxBG.beginFill(0x000000);
    // this.messageBoxBG.drawRoundedRect(0, 0,800,350,this.roundness);
    this.messageBoxBG.drawRoundedRect(0, 0, 800, 350, this.roundness);
    this.messageBoxBG.endFill();
    this.messageBoxContainer.addChild(this.messageBoxBG);
    this.messageBoxBG.alpha = 0;
    this.headText = new PIXI.Text("o", this.headTextStyle);
    this.bodyText1 = new PIXI.Text("l", this.bodyText1Style);    
    this.bodyText1.anchor.set(0.5, 0);
    this.bodyText2 = new PIXI.Text("", this.headTextStyle);    
    this.bodyText2.anchor.set(0.5, 0);


    this.headText.y =0// this.headText.height;
    // this.bodyText1.y=this.messageBoxBG.height/2-this.bodyText1.height/2;
    this.bodyText1.y = this.bodyText1.height * 3;
    this.bodyText1.x =this.messageBoxBG.width / 2 - this.bodyText1.width / 2;
    this.bodyText2.x =this.messageBoxBG.width / 2 - this.bodyText2.width / 2;
    this.messageElemContainer.addChild(this.headText);
    this.messageElemContainer.addChild(this.bodyText1);
    this.messageElemContainer.addChild(this.bodyText2);
    this.messageElemContainer.addChild(this.btnContainer);

    this.setNewBtn(this.btnCount);

    //create tween

    // this.fireFrame.anchor.set(0.5);
    // this.fireFrame.scale.set(1.25)
    //  this.fireFrame.x=this.fireFrame.width/2;
    //   this.fireFrame.y=this.fireFrame.height/2-50;
    // this.fireFrame.blendMode = PIXI.BLEND_MODES.SCREEN;
    // this.msgFrame.addChild(  this.fireFrame)

    // this.messageElemContainer
  };


  private setNewBtn = (btnCount: number): void => {
    //set new btn

    for (var i: number = 0; i < btnCount; i++) {
      this.btnShape[i] = new PIXI.Graphics();
      this.btnShape[i].beginFill(0xffcf64);
      this.btnShape[i].lineStyle(3, 0xfefbf2, 0.7, 1);
      this.btnShape[i].drawRoundedRect(0, 0, 300, 75, 5);
      this.btnShape[i].endFill();
      this.btnShape[i].x = i * this.btnShape[i].width * 1.25; //Stroke offset
      this.btnShape[i].y = this.boxHeight - this.btnShape[i].height * 1.5;
      this.btnContainer.addChild(this.btnShape[i]);
      this.btnContainer.x = this.boxWidth / 2 - this.btnContainer.width / 2; //centerBTN

      this.btnLabel[i] = new PIXI.Text(i.toString(), this.labelTextStyle);
      this.btnLabel[i].x =
        this.btnShape[i].width / 2 - this.btnLabel[i].width / 2;
      this.btnLabel[i].y =
        this.btnShape[i].height / 2 - this.btnLabel[i].height / 2;
      this.btnShape[i].addChild(this.btnLabel[i]);
      this.btnShape[i].interactive = false;
      this.btnShape[i].buttonMode = false;
    }
  };

  public setBtns = (
    btnCount: number,
    label: Array<string>,
    fn: Array<()=> void>
  ): void => {
    this.btnShape = [];
    this.btnCount = btnCount;
    this.setNewBtn(btnCount); //rewrite existing ones;

    for (let i = 0; i < label.length; i++) {
      this.setLabel(i, label[i]);
      // console.log( label.length,i)
      this.setButtons(i, fn[i]);
    }
  };
  private createTween = (): void => {
    this.messageBoxInTween = PIXI.tweenManager.createTween(
      this.nullPosition
    );
    this.messageBoxInTween.from({alpha: 0 }).to({alpha: 1 });
    this.messageBoxInTween.time = 1; //300 ease in default
    // this.messageBoxInTween.delay = 1500; //300 ease in default
    this.messageBoxInTween.easing = PIXI.tween.Easing.outBack();
    // this.messageBoxInTween.loop=true
    this.messageBoxOutTween = PIXI.tweenManager.createTween(
      this.nullPosition
    );
    this.messageBoxOutTween.from({alpha: 1 }).to({ alpha: 0 });
    this.messageBoxOutTween.time = 1; //300 ease in default
    this.messageBoxOutTween.easing = PIXI.tween.Easing.linear();



  };

  // public setChildOf(
  //   parent: PIXI.Container //center By default
  // ) {
  //   parent;
  //   // parent.addChild(this.parent);

  //   this.activeGameData.messageContainer.addChild(this.parent);
  //   this.messageBoxContainer.x =
  //     this.parentSize[0] / 2 - this.messageBoxContainer.width / 2;
  //   this.messageBoxContainer.y =
  //     this.parentSize[1] / 2 - this.messageBoxContainer.height / 2;

  //   //RECENTER BOODY TEXT
  //   this.messageBoxBG.x =
  //     this.messageBoxContainer.width / 2 - this.messageBoxBG.width / 2;

  //   this.setMessageBoxVisibile(false);
  // }


  private  setPositionAndParent(
    // parent: PIXI.Container //center By default
  ) {
    // parent;
    // parent.addChild(this.parent);

    this.activeGameData.messageContainer.addChild(this.parent);
    this.messageBoxContainer.x =
      this.parentSize[0] / 2 - this.messageBoxContainer.width / 2;
    this.messageBoxContainer.y =
      this.parentSize[1] / 2 - this.messageBoxContainer.height / 2;

    //RECENTER BOODY TEXT
    this.messageBoxBG.x =
      this.messageBoxContainer.width / 2 - this.messageBoxBG.width / 2;

    this.setMessageBoxVisibile(false);
  }

  public setHeadText = (text: string): void => {
    this.headText.text = text;
    this.headText.x = this.boxWidth / 2 - this.headText.width / 2;
  };

  public setBodyText = (text: string): void => {
    this.bodyText1.text = text;
    this.bodyText1.x = this.boxWidth / 2;
    //--clear the last bit by default , only display if specified
    this.setBodyText2("");
  
  };

  public setAllowBlackScreen=(bool:boolean):void=>
  {
      this.enableBlackenScreen=bool;
  }
  public setBodyText2 = (text: string): void => {
    this.bodyText2.text = text;
    this.bodyText2.x = this.boxWidth / 2;
    // this.bodyText2.alpha=1;
  };

  public setLabel = (i: number, label: string): void => {
    // console.log(label)
    this.btnLabel[i].text =" "+ label+" ";
    this.btnLabel[i].x = 300 / 2 - this.btnLabel[i].width / 2;
  };

  public setButtons = (i: number, fn: ()=> void): void => {
    this.btnShape[i].interactive = false;
    this.btnShape[i].buttonMode = false;
    // this.btnShape[i].hitArea=new PIXI.Rectangle(0,0, 300,75);
    this.btnShape[i].on("pointertap", fn); //execute les functions
    // this.btnShape[i].on('pointertap',this.openMessageWindow.bind(this,false));
    this.btnShape[i].on("pointertap", this.autoClose);
  };

  public clearFunction = (i: number): void => {
    this.btnShape[i].removeAllListeners();
  };

  private autoClose = (): void => {
    // console.log('autoClosed')
    this.setMessageBoxVisibile(false,1);
  };
  public setMessageType(msgType: number) {
  
    // msgType=1
    if (msgType == -1) {
      //error message
      this.msgFrame.texture = this.msgErrTexture;
      // this.errorIcon.alpha = 0.25;
    }
    if (msgType == 0) {
      //default message
      this.msgFrame.texture = this.msgDefaultTexture;
    }
    if (msgType == 1) {
      //win message
      this.winBGFx_L.alpha=1;
      this.winBGFx_R.alpha=1;
      this.msgFrame.texture = this.msgWinTexture;
      this.winElements.alpha = 1;
      // this.winElementsR.alpha=1;
      //-add other styles
    }
  }

  private hideAlldeco=():void=>
  {
  //hidee all decos
  for (let i = 0; i < this.msgDecorations.length; i++) {
    this.msgDecorations[i].alpha = 0;
  }
  }

  public setMessageBoxVisibile = (
    openWindow: boolean=true,
    type: number = 0
  ): void => {
// this.messageElemContainer
 
    // type=-1;
    this.hideAlldeco();
    if (openWindow) {
      this.setMessageType(type);
    }

    this.isOpen = openWindow;

    // this.isOpen=true
    if (this.headText.text == "" || this.headText.text == " ") {
      this.bodyText1.y = this.headText.height;
      // console.log(this.bodyText1.y)
    } else {
      this.bodyText1.y = this.headText.y + 80;
    }

    this.bodyText2.x =this.messageBoxBG.width / 2// - this.bodyText2.width / 2;
    this.bodyText2.y=this.bodyText1.height+this.bodyText1.y;
    // console.log(this.bodyText2.text)

    if(this.bodyText2.text!="")
    {
        this.bodyText2.alpha=1;
    }
    else
    {
        this.bodyText2.alpha=0;
    }
    if (this.isOpen == false) {
      // this.messageBoxContainer.alpha = 0;
      this.parent.alpha = 0;
      // this.fireFrame.stop();
      this.messageBoxInTween.stop();
      this.messageBoxOutTween.reset();
      this.messageBoxOutTween.start();

    } else {
      this.messageBoxOutTween.stop();
      this.messageBoxInTween.reset();
      this.messageBoxInTween.start();
      this.parent.alpha = 1;

      // console.log(this.btnCount)
     
    }
    //Disable Buttons Interactivites
    for (var i = 0; i < this.btnCount; i++) {
      this.btnShape[i].interactive =openWindow;
      this.btnShape[i].buttonMode = openWindow;
    }

  
    if(this.enableBlackenScreen)
    { 
      // console.log(this.enableBlackenScreen)
      if (this.activeGameData.blackScreen != undefined) {
        this.activeGameData.blackScreen.setVisible(openWindow); //
      
      }
    }
 
   

  };
  public setBtnClickable=(bool:boolean):void=>
  {
    for (var i = 0; i < this.btnCount; i++) {
      this.btnShape[i].interactive =bool;
      this.btnShape[i].buttonMode = bool;
    }
  }

  // close()
  // {
  //     this.setMessageBoxVisibile(false);
  // }

  public setMessageBoxPosY = (newValue: number): void => {
    // this.messageBoxContainer.y=newValue;
    newValue;
  };
  public getIsOpen = (): boolean => {
    return this.isOpen;
  };
}
